module.exports = __webpack_public_path__ + "static/media/mh_entrium_06.7f7cba06.png";